import { apiDate, apiDateString, JsonPrimitiveSchema, number, string, z, ZodType, zrecord, zunion } from '@kaiizen/zod-less';
import { Simplify } from 'type-fest';
import { ZodRawShape } from 'zod';

const NUMBER_FROM_STRING_REGEX = /^-?\d+(\.\d+)?$/;
const findNumberFromString = (value: string) => {
  const match = value.match(NUMBER_FROM_STRING_REGEX);
  if (match) {
    const num = parseFloat(match[0]);
    if (isNaN(num)) {
      return undefined;
    }
    return num;
  }
  return undefined;
};

export const numberOrNumberFromString = zunion(
  number,
  string.transform(findNumberFromString).meta({ type: 'number' } as any),
).meta({ type: 'number' });

export const optionalNumberOrNumberFromString = numberOrNumberFromString.optional();

export const optionalApiDate = apiDate.optional();
export const MetadataSchema = z.union([
  zrecord(zunion(JsonPrimitiveSchema, apiDateString)),
  z.any().pipe(z.record(z.string(), z.any())),
]);
export const optionalMetadataSchema = MetadataSchema.optional();

export const makePartialMetadataSchema = <RawShape extends ZodRawShape>(
  rawSchema: RawShape,
): ZodType<Simplify<z.infer<z.ZodObject<RawShape>>>> =>
  z
    .union([zrecord(z.unknown()), z.any()])
    .transform(value => typeof value === 'object' && value !== null && !Array.isArray(value) ? value : {})
    .pipe(z.object(rawSchema).catchall(z.unknown())) as any;

export const makeOptionalPartialMetadataSchema = <RawShape extends ZodRawShape>(rawSchema: RawShape) => makePartialMetadataSchema(rawSchema).optional();

export const LimitSchema = z.coerce.number().int().min(1);
